import React from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'react-flexbox-grid';
import FormItem from 'common/components/formItem/FormItem';
import { ReactComponent as TrashIcon } from 'assets/svg/trash_no_color.svg';
import { Controller, UseFormMethods } from 'react-hook-form';
import Label from 'common/components/label/Label';
import styles from './GpsLocatorFormItem.module.scss'
import Select from 'common/components/select/Select';
import InputError from 'common/components/inputError/InputError';
import { SelectValueLabel } from 'common/types/SelectValueLabel';
import Input from 'common/components/input/Input';
//import InputGroup from 'common/components/inputGroup/InputGroup';

type Props = {
    form: UseFormMethods<any>;
    isDetails: boolean
    onRemoveClick: () => void;
    index: number;
    gpsLocatorList: SelectValueLabel[];
    setRender: () => void;
} & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

const GpsLocatorFormItem: React.FC<Props> = ({
    form,
    isDetails,
    onRemoveClick,
    index,
    gpsLocatorList,
    setRender,
    ...props
}: Props) => {
    const { t } = useTranslation();
    const errors = (form.errors?.gpsLocators || [])[index] || null;

    return (
        <div
            {...props}
            className={`${styles.container} ${(errors && styles.containerError) || ''} ${props.className || ''}`}
        >
            <Row>
                <Col xs={12} sm={12} lg={4}>
                    <FormItem>
                        <Label className={styles.label}>
                            {t('gps_locator.type')}*
                        </Label>
                        <Controller
                            render={({ onChange, value }) => {
                                return (
                                    <Select
                                        options={gpsLocatorList}
                                        isClearable
                                        placeholder={t('gps_locator.type')}
                                        onChange={(e: SelectValueLabel) => {
                                            form.setValue(`gpsLocators[${index}].gpsLocatorId`, e ? e.value : null);
                                            setRender()
                                        }}
                                        isDisabled={isDetails}
                                        value={gpsLocatorList.find(x => x.value === value) ? gpsLocatorList.find(x => x.value === value) : null}
                                    />
                                );
                            }}
                            rules={{ required: true }}
                            control={form.control}
                            name={`gpsLocators[${index}].gpsLocatorId`}
                            defaultValue={form.getValues(`gpsLocators[${index}].gpsLocatorId`)} />
                        <InputError error={errors?.gpsLocatorId} />
                    </FormItem>
                </Col>
            </Row>
            <Row>
                <Col xs={12} sm={12} lg={4}>
                    <FormItem>
                        <Label className={styles.label}>{t('gps_locator.username')}*</Label>
                        <Controller
                            render={({ ref, onChange, value }) => {
                                return (
                                    <Input
                                        {...props}
                                        ref={ref}
                                        disabled={isDetails}                                        
                                        onChange={(e: any) => {
                                            form.setValue(`gpsLocators[${index}].username`, e.currentTarget.value);                                                                                        
                                            setRender()
                                        }}
                                        value={value}
                                    />
                                );
                            }}
                            control={form.control}
                            name={`gpsLocators[${index}].username`}
                            defaultValue={form.getValues(`gpsLocators[${index}].username`)}
                            rules={{ required: true }}
                            placeholder={t('gps_locator.username')} />
                            <InputError error={errors?.username} />
                    </FormItem>
                </Col>



                <Col xs={12} sm={12} lg={6}>
                    <FormItem>
                         <Label className={styles.label}>{t('gps_locator.password')}*</Label>
                        <Controller
                            render={({ ref, onChange, value }) => {
                                return (
                                    <Input                                    
                                        {...props}
                                        type={'password'}
                                        ref={ref}
                                        disabled={isDetails}                                        
                                        onChange={(e: any) => {
                                            form.setValue(`gpsLocators[${index}].password`, e.currentTarget.value);                                                                                        
                                            setRender()
                                        }}
                                        value={value}
                                    />
                                );
                            }}
                            control={form.control}
                            name={`gpsLocators[${index}].password`}
                            defaultValue={form.getValues(`gpsLocators[${index}].password`)}
                            rules={{ required: true }}
                            placeholder={t('gps_locator.password')} />
                            <InputError error={errors?.password} />
                    </FormItem>
                </Col>


                {/* <Col xs={12} sm={12} lg={4}>
                    <FormItem>
                        <Label className={styles.label}>{t('gps_locator.password')}*</Label>
                         <Controller
                            render={({ ref, onChange, value }) => {
                                return (
                                     <Input
                                        {...props}
                                        ref={ref}
                                        disabled={isDetails}                                      
                                        onChange={(e: any) => { 
                                            form.setValue(`gpsLocators[${index}].password`, e.currentTarget.value);                                            
                                            setRender()
                                        }}                                      
                                    />
                                );
                            }}
                            control={form.control}
                            name={`gpsLocators[${index}].password`}
                            defaultValue={form.getValues(`gpsLocators[${index}].username`)}
                            rules={{ required: true }}
                            placeholder={t('gps_locator.password')} />
                        <InputError error={errors?.password} />
                    </FormItem>
                </Col> */}


                {!isDetails && <Col xs={1} sm={1} lg={1} style={{ display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
                    <div className={styles.removeButton}>
                        <TrashIcon className={styles.removeIcon} onClick={onRemoveClick} />
                    </div>
                </Col>}
            </Row>
        </div>
    );
}

export default GpsLocatorFormItem;
